import { render } from "./chat.vue?vue&type=template&id=13cd90b8&scoped=true"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"

import "./chat.vue?vue&type=style&index=0&id=13cd90b8&scoped=true&lang=css"

import exportComponent from "/var/www/worldchatbox/node_build/worldchatbox_dev2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cd90b8"]])

export default __exports__